import React from 'react';
import TituloTexto from '../../../layout/titulo-texto';

const PagoCancelado = () => {
  const texto = 'Tu pago no se pudo procesar pero tu reserva quedo activa por 48 hs, contactate con nosotros para finalizar tu compra';
  return (
    <TituloTexto titulo='Has cancelado el pago' texto={texto} />
  );
};

export default PagoCancelado;
